import { $, $$ } from './_queryselector.js';
import scrollMonitor from './_scroll_monitor.js';
import * as _ from './_helpers.js';
import * as Hero from './_hero.js';
import Counter from './_counter.js';
import * as Events from './_events.js';

let monitors = [];

const $nav = document.querySelector('.js-site-nav');
const $navList = document.querySelector('.js-site-nav-list');
let $shapes;
let $shapesShapes;
let $shapesImage;
let navHidden = false;

export function attach(container) {
    $shapes = $('.js-shapes');
    if ($shapes) {
        $shapesShapes = $('.js-shapes-shapes');
        $shapesImage = $('.js-shapes-image');
    }

    container = typeof container === 'undefined' ? document : container;

    const inViewEls = $$('.js-in-view:not(.-in-view)', container);
    const scrollWatchers = [];
    for (let i = 0; i < inViewEls.length; i++) {
        let offset = inViewEls[i].hasAttribute('data-offset')
            ? parseInt(inViewEls[i].getAttribute('data-offset'), 10)
            : 0;
        let scrollWatcher = scrollMonitor.create(
            inViewEls[i],
            scrollMonitor.viewportHeight / -10 - offset
        );
        scrollWatchers.push(scrollWatcher);
        monitors.push(scrollWatcher);
    }

    function showElement(e) {
        if (typeof e === 'undefined') return;
        if (!this.isInViewport) return;

        this.destroy();

        requestAnimationFrame(() => {
            this.watchItem.classList.add('-in-view');
        });
    }

    scrollWatchers.forEach(watcher => {
        if (watcher.isInViewport) {
            showElement.bind(watcher, null)();
        } else {
            watcher.enterViewport(showElement);
        }
    });

    /**
     * Expose videos
     */
    {
        const videos = document.querySelectorAll('.js-expose-video video');
        let activeVideo = null;

        if (videos.length) {
            _.isAutoplaySupported(supported => {
                for (let i = 0; i < videos.length; i++) {
                    if (!supported) {
                        // replace video with fallback image
                        const image = document.createElement('img');
                        image.src = videos[i].getAttribute('data-img');
                        image.alt = videos[i].getAttribute('data-alt') || '';
                        videos[i].parentNode.replaceChild(image, videos[i]);

                        continue;
                    }

                    videos[i].addEventListener('ended', () => {
                        setTimeout(() => {
                            if (videos[i] === activeVideo) {
                                videos[i].play();
                            }
                        }, 2000);
                    });

                    const watcher = scrollMonitor.create(
                        videos[i],
                        scrollMonitor.viewportHeight / -10
                    );

                    watcher.stateChange(function() {
                        if (this.isFullyInViewport) {
                            activeVideo = this.watchItem;
                            this.watchItem.play();
                        }
                    });
                }
            });
        }
    }

    /**
     *
     */
    {
        const iframes = $$('.js-article iframe[data-src]');
        for (let i = 0; i < iframes.length; i++) {
            const watcher = scrollMonitor.create(
                iframes[i],
                scrollMonitor.viewportHeight / -10
            );
            watcher.enterViewport(function() {
                this.watchItem.setAttribute(
                    'src',
                    this.watchItem.getAttribute('data-src')
                );
                this.destroy();
            });
        }
    }

    /**
     * Counters on case studies
     */
    {
        if (!parallax.isAdmin) {
            const counter = $('.js-counter');

            if (counter) {
                Counter.init(counter);

                const monitor = scrollMonitor.create(
                    counter,
                    scrollMonitor.viewportHeight / -10
                );
                monitors.push(monitor);

                monitor.enterViewport(() => {
                    Counter.animate();
                    monitor.destroy();
                });
            }
        }
    }
}

/* Changed hidePoint to 10 as it needs to disappear earlier

let navPadding = window.getComputedStyle($nav, null).getPropertyValue('padding-top');
let hidePoint = (navPadding ? parseInt(navPadding, 10) : 100);

window.addEventListener('resize',  _.throttle(() => {
    navPadding = window.getComputedStyle($nav, null).getPropertyValue('padding-top');
    hidePoint = (navPadding ? parseInt(navPadding, 10) : 100);
}));*/

const hidePoint = 10;

export function destroy() {
    for (let i = 0; i < monitors.length; i++) {
        monitors[i].destroy();
    }
    monitors = [];
}

const $firstNavItem = $navList.firstElementChild;
const $lastNavItem = $navList.lastElementChild;

function updateNav(scrollPos = 0) {
    if (!navHidden && scrollPos > hidePoint) {
        navHidden = true;
        $nav.addEventListener(
            'animationend',
            _.once(() => {
                $nav.classList.remove('-out-h');
                $nav.classList.add('-in-v');
            })
        );
        $nav.classList.remove('-in-h');
        void $nav.offsetWidth;
        $nav.classList.add('-out-h');
    } else if (navHidden && scrollPos <= hidePoint) {
        navHidden = false;
        $firstNavItem.addEventListener(
            'animationend',
            _.once(() => {
                $nav.classList.remove('-out-v');
                $nav.classList.add('-in-h');
            })
        );
        $nav.classList.remove('-in-v');
        void $nav.offsetWidth;
        $nav.classList.add('-out-v');
    }
}

export function setNavHidden(value) {
    navHidden = value;
}

/**
 * Background color changer
 */
let els;
let tops;

const bgs = [document.querySelector('.bg-0'), document.querySelector('.bg-1')];
let active = 0;

let colors;
let activeColor;
let activeSection;
let elsReverse;

function setupBg() {
    els = document.querySelectorAll('[data-bg]');

    tops = [];
    colors = [];
    activeColor = '';
    activeSection = null;

    for (let i = 0; i < els.length; i++) {
        let style = window.getComputedStyle(els[i]);
        if (style.display !== 'none') {
            tops.push(
                els[i].getBoundingClientRect().top -
                    document.body.getBoundingClientRect().top
            );
            colors.push(els[i].getAttribute('data-bg'));
        }
    }

    elsReverse = [].slice.call(els, 0);
    elsReverse.reverse();
    tops.reverse();
    colors.reverse();
}
setupBg();

let lastKnownScrollPosition = 0;
let ticking = false;
let backgroundPaused = false;

const white = document.querySelector('.bg-white');
const shapes = document.querySelector('.js-shapes');
let showShapes = true;

export function setBackgroundColor(color, index) {
    if (color !== activeColor) {
        if (parallax.pageName === 'home' && shapes) {
            if (index === tops.length - 2) {
                showShapes = false;
                white.addEventListener(
                    'transitionend',
                    _.once(() => {
                        if (!showShapes) {
                            Hero.setPaused(true);
                        }
                    })
                );
            } else if (index === tops.length - 1) {
                showShapes = true;
                Hero.setPaused(false);
            }
        }

        document.body.classList.remove(`body--${activeColor}`);
        document.body.classList.add(`body--${color}`);

        activeColor = color;
    }
}

export function updateBackground(scrollPos = 0) {
    for (let i = 0; i < tops.length; i++) {
        if (tops[i] - scrollPos <= _.windowHeight / 2) {
            if (activeSection && elsReverse[i] != activeSection) {
                activeSection.classList.remove('-active');
                elsReverse[i].classList.add('-seen');
                elsReverse[i].classList.add('-active');
            }
            activeSection = elsReverse[i];
            setBackgroundColor(colors[i], i);
            break;
        }
    }
}
updateBackground();

export function setBackgroundPaused(value) {
    backgroundPaused = value;
}

window.addEventListener('scroll', () => {
    if (backgroundPaused) return;

    lastKnownScrollPosition = window.pageYOffset;
    if (!ticking) {
        window.requestAnimationFrame(() => {
            updateBackground(lastKnownScrollPosition);
            updateNav(lastKnownScrollPosition);
            ticking = false;
        });
    }
    ticking = true;
});

window.addEventListener(
    'resize',
    _.throttle(() => {
        recalcBackgroundSections();
        updateBackground(lastKnownScrollPosition);
    })
);

export function recalcBackgroundSections(reset = false) {
    if (reset) {
        setupBg();

        // remove classes of format: body--[a-zA-Z_-]
        const oldClasses = document.body.className;
        const newClasses = oldClasses
            .replace(/\s*body--[a-zA-Z_-]+\s*/g, ' ')
            .trim();
        document.body.className = newClasses;
    } else {
        tops.length = 0; // clear array
        for (let i = 0; i < els.length; i++) {
            tops.push(
                els[i].getBoundingClientRect().top -
                    document.body.getBoundingClientRect().top
            );
        }
        tops.reverse();
    }
}

export function eventsNavInit() {
    const $monthContainers = $$('.js-events-month-container');
    const currentMonth = $('[data-current-month="true"]').getAttribute(
        'data-month'
    );
    const $eventsNav = $('.js-events-nav');
    const $eventsNavItems = $$('.js-events-nav-item');

    let monthScrollWatchers = [];

    setupBg();

    // Commenting out active state for now***
    $('.js-events-nav-item--' + currentMonth).classList.add('-selected');

    function updateEventsNav($el) {
        let month = $el.getAttribute('data-month');

        let $targetElement = $('.js-events-nav-item--' + month);

        for (let i = 0; i < $eventsNavItems.length; i++) {
            $eventsNavItems[i].classList.remove('-selected');
        }

        $targetElement.classList.add('-selected');
    }

    function setUpWatchers() {
        for (var i = $monthContainers.length - 1; i >= 0; i--) {
            let $el = $monthContainers[i];

            let monthScrollWatcher = scrollMonitor.create($el);
            monthScrollWatchers.push(monthScrollWatcher);

            monthScrollWatcher.fullyEnterViewport(e => {
                // Commenting out active state
                //updateEventsNav($el);
            });
        }
    }

    function openEventsNavMob($el) {
        if (_.isMobile || _.windowWidth < 581) {
            if ($el.classList.toString().indexOf('-selected') < 0) {
                $eventsNav.classList.remove('-mob-open');

                // ***Manage selected state whilst scrollwatcher update is turned off (see above)
                for (var i = $eventsNavItems.length - 1; i >= 0; i--) {
                    $eventsNavItems[i].classList.remove('-selected');
                }
                $el.classList.add('-selected');
            } else {
                $eventsNav.classList.add('-mob-open');
            }
        }
    }

    function eventsNavScrollTo(e) {
        e.stopPropagation();
        let $el = e.target;
        let isSelected = false;

        if ($el.classList.toString().indexOf('events-nav__item') < 0) {
            $el = $el.parentElement;
        }

        if (!$el.classList.toString().indexOf('-selected') < 0) {
            isSelected = true;
        }

        openEventsNavMob($el);

        let month = $el.getAttribute('data-month');
        let targetClass = '.js-events-month-container--' + month;
        let $monthContainer = $(targetClass);
        let scrollY =
            Events.elementYPosition($('.js-events')).y +
            Events.elementYPosition($monthContainer).y;

        if (!isSelected) {
            scrollTo(0, scrollY);
        }
    }

    setUpWatchers();

    for (let j = 0; j < $eventsNavItems.length; j++) {
        $eventsNavItems[j].addEventListener('click', function(e) {
            eventsNavScrollTo(e);
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/_scroll.js